import { validateVersion } from './validateVersion'

// This set of code sets the links for the previous and next buttons of the navigation
export default function checkSegmentExists(segmentID, AvailableContent, language, version) {
  console.log(
    `getBookOfSegment [checkSegmentExists]`, segmentID,
    language,
    version
  )
  if (AvailableContent) {
    if (!validateVersion(AvailableContent, language, version)) return null
    const books = Object.keys(
      AvailableContent.content[language][version]
    )
    let bookOfSeg = false
    books.forEach(book => {
      if (
        AvailableContent.content[language][version][
          book
        ].segments.indexOf(segmentID) !== -1
      ) {
        bookOfSeg = book
      }
    })
    return bookOfSeg
  }
  return null
}
